import { useRef, useState } from 'react';
import type { ButtonProps } from '@amzn/awsui-components-core/button';
import { studioSelectedOption } from 'src/components/star-grid/utils/studioSelect';
import type { StudioScenarioBlock } from 'src/components/star-grid/reportStudio.types';
import type { ReportStudioState } from 'src/components/star-grid/hooks/useReportStudio';
import { studioSelectionSummary } from 'src/components/star-grid/utils/studioMultiselect';
export const useStudioPreviewFilters = (state: ReportStudioState) => {
  const [currenciesOpen, setCurrenciesOpen] = useState(false);
  const currencyTrigger = useRef<ButtonProps.Ref>(null);
  const dismissCurrencies = () => {
    setCurrenciesOpen(false);
    currencyTrigger.current?.focus();
  };
  const toggleCurrency = (column: StudioScenarioBlock, id: string, checked: boolean) =>
    state.updateColumn({ ...column, currency_ids: checked ? [...column.currency_ids, id] : column.currency_ids.filter((value) => value !== id) });
  const currencyChoices = (selected: readonly string[]) =>
    [...new Set([...state.dataset.currencies.map((currency) => currency.id), ...selected])].map((id) => ({
      id,
      label: studioSelectedOption(state.dataset.currencies, id).label
    }));
  const scenarios = state.deck.columns.filter((column): column is StudioScenarioBlock => column.kind === 'scenario');
  const currencies = [...new Set(scenarios.flatMap((column) => column.currency_ids))];
  const currencySummary = currencies.length
    ? studioSelectionSummary(
        currencies.map((value) => ({ value, label: state.dataset.currencies.find((item) => item.id === value)?.label ?? value })),
        state.text
      )
    : state.text('studioDefaultFX');
  const parameters = state.template.parameters.filter((parameter) => parameter.role !== 'display' && parameter.role !== 'currency');
  const currencyParameters = state.template.parameters.filter((parameter) => parameter.role === 'currency');
  return {
    currenciesOpen,
    setCurrenciesOpen,
    currencyTrigger,
    dismissCurrencies,
    closeCurrencies: () => setCurrenciesOpen(false),
    toggleCurrency,
    currencyChoices,
    scenarios,
    currencySummary,
    parameters,
    currencyParameters
  };
};
